import { render, staticRenderFns } from "./material-category-distribution.vue?vue&type=template&id=5ef686df&scoped=true"
import script from "./material-category-distribution.vue?vue&type=script&lang=js"
export * from "./material-category-distribution.vue?vue&type=script&lang=js"
import style0 from "./material-category-distribution.vue?vue&type=style&index=0&id=5ef686df&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef686df",
  null
  
)

export default component.exports